export default __webpack_public_path__ + "static/media/tridant.66d1f485.png";